module.exports = __webpack_public_path__ + "static/img/57.20d6b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/57.png
// module id = AnE/
// module chunks = 0